import template from './add_cycle_step.html';
import * as Utils from '../../lib/savanna_utils.js';

class AddCycleStepViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.performance_cycle_id = ko.observable();
		this.name = ko.observable();
		this.selected_rules = ko.observableArray();
		this.available_rules = ko.observableArray();
		this.cycle_name = ko.observable();
		this.step_sequence = ko.observable();
	};

	close()
	{
		this.dialog.close();
	}

	async btn_save_step()
	{
		let rules;
		if (this.selected_rules())
			rules = this.selected_rules().map(x => x.step_rule_id) || [];

		if (!this.name())
		{
			Grape.alerts.alert({ type: 'warning', message: 'Stage name cannot be empty!'});
			return;
		}
		else
		{
			let options;
			try {
				if (!this.performance_cycle_id())
				{
					options = {
						name: this.name(),
						rules: [],
						step_sequence: this.step_sequence(),
						action: 'edit'
					}
				}
				else
				{
					options = {
						performance_cycle_id: this.performance_cycle_id(),
						name: this.name(),
						rules: JSON.stringify(rules),
						step_sequence: this.step_sequence(),
						status: 'Not Started'
					}
				}

				let res = await Grape.fetches.postJSON('/performance_management/cycle_step/edit', options );

				if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else if (res.status == 'OK')
				{
					Grape.alerts.alert({type: 'success', message: 'Successfully saved new stage'});
					this.dialog.close(true);
				}
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({ type: 'error', message: 'An error occurred - ', error});
			}
		}
	}
};

class AddCycleStepPage
{
	constructor (bindings)
	{
		this.viewModel = new AddCycleStepViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();
		this.viewModel.cycle_name(this.bindings.cycle.cycle_name);
		this.viewModel.performance_cycle_id(this.bindings.cycle.performance_cycle_id);
		this.viewModel.step_sequence(this.bindings.step_sequence);
		this.viewModel.available_rules(this.bindings.rules);
	}

	async updateData()
	{}
};

export default {
	name: 'AddCycleStep',
	dialog_class: AddCycleStepPage,
	template: template,
	template_filename: 'translation/dialogs/add_cycle_step',
	provider: 'ps'
};